import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'lib-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true
    }
  ],
  standalone: false
})
export class CheckboxComponent implements OnInit, ControlValueAccessor {
  @Input()
  label: string;
  // if no id supplied, generate 'random' one so label click can toggle the checkbox value
  @Input()
  id: string = Math.random().toString(36).substring(2);
  @Input()
  size: CheckboxSizes = CheckboxSizes.Large;
  possibleSizes = CheckboxSizes;
  value: boolean;
  disabled: boolean;

  onChange = _ => {};

  constructor() {}

  ngOnInit(): void {}

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {}

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(obj: any): void {
    this.value = obj;
  }
  valueChanged(val: boolean) {
    this.value = val;
    this.onChange(val);
  }
}

export enum CheckboxSizes {
  Small,
  Medium,
  Large
}
